import type React from 'react';

import type { EventRecord } from '@vlabs/api/artemy/model';
import type { Event } from '@vlabs/api/luna-api/model';
import type { WithClassNameProp, WithDataTestid } from '@vlabs/uikit/types';
import cn from 'classnames';

import { buildTestid } from '@vlabs/monokit/shared/lib/utils';

import st from './AttributesCell.module.sass';
import { BodyAttributesRow } from './BodyAttributesRow';
import { FaceAttributesRow } from './FaceAttributesRow';

interface AttributesCellBaseProps extends WithClassNameProp, WithDataTestid {
  children?: React.ReactNode;
  displayName: string;
  event?: Event | EventRecord;
}

function AttributesCellBase({
  children = null,
  displayName,
  event = undefined,
  className = undefined,
  'data-testid': dataTestId = undefined,
}: AttributesCellBaseProps): React.JSX.Element | null {
  const testid = buildTestid(displayName);

  if (!event) return null;

  const {
    accessories,
    age: faceAge,
    body_basic_attributes: bodyBasicAttributes,
    gender: faceGender,
    lower_body: lowerBody,
    upper_body: upperBody,
  } = event;
  const bodyAge = bodyBasicAttributes?.apparent_age;
  const bodyGender = bodyBasicAttributes?.apparent_gender;

  // если у лица нет атрибутов лица тела, то будем показывать пол/возраст из тела
  let age: number | null | undefined = bodyAge;
  let gender: number | null | undefined = bodyGender;
  const hasFaceBasicAttributes = (faceAge !== null && faceAge !== undefined)
    || (faceGender !== null && faceGender !== undefined);
  if (hasFaceBasicAttributes) {
    // если у лица есть базовые атрибуты, показываем их вместо фолбэка из тела
    age = faceAge;
    gender = faceGender;
  }

  return (
    <div
      className={cn(st.AttributesCell, className)}
      {...testid(dataTestId)}
    >
      <FaceAttributesRow
        age={age}
        gender={gender}
      >
        {children}
      </FaceAttributesRow>

      <BodyAttributesRow
        accessories={accessories}
        lowerBody={lowerBody}
        upperBody={upperBody}
      />
    </div>
  );
}

export { AttributesCellBase };
